import type { RequestInfo } from '@warp-drive/core-types/request';
import { buildBaseURL } from '@warp-drive/utilities';

/**
 * GET /me materializes the current user and app-specific included relationships through the
 * authenticated store. Include paths may be comma-joined or passed as an array.
 * Always reloads from the network so role grants and terms acceptance update session gates.
 */
export function meRequest(includes: string | readonly string[]): RequestInfo {
  const base = buildBaseURL({
    identifier: { type: 'users' },
    op: 'query',
    resourcePath: 'me',
  });
  const include = Array.isArray(includes) ? includes.join(',') : includes;
  return {
    url: `${base}?include=${include}`,
    method: 'GET',
    op: 'query',
    cacheOptions: { reload: true },
  };
}
